import { JobBoardsVacanciesStatusEnum } from 'generated/api'
import { TVariant } from 'components/badge/Badge'

export default function jobVacancyStatusBadgeVariant(
  status: JobBoardsVacanciesStatusEnum,
): TVariant {
  return status === JobBoardsVacanciesStatusEnum.Active ? 'info' : 'success'
}
